import './meow.css'; 

const Hero = () => {
  return (
    <div className="meo">
      <div className="overlay">
        <p className="discount-banner">🔥 Get up to 50% OFF on selected items! Limited time offer.</p>
        <button className="meo-button">SHOP NOW</button>
      </div>
    </div>
  );
};

export default Hero;
